import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteExternalConnection } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';

import { queryKey as externalEventsQueryKey } from './use-external-calendar-events-query';

export const useDeleteExternalConnectionMutation = () => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: async (id: ID) => {
      deleteExternalConnection(id);

      await client.invalidateQueries({ queryKey: [externalEventsQueryKey] });
    },
  });
};
